<x-ghost-product-media class="mb-3"></x-ghost-product-media>
<x-ghost-title class="mb-3"></x-ghost-title>
<x-ghost-paragraph></x-ghost-paragraph>
